import React, { useEffect, useRef, useState } from "react";
import {
  Table,
  Avatar,
  Input,
  DatePicker,
  Select,
  Button,
  Space,
  Card,
  Tooltip,
  Switch,
  Breadcrumb,
  Progress,
  Spin,
  Tag,
  Collapse,
} from "antd";
import {
  FilePdfOutlined,
  FileWordOutlined,
  DownloadOutlined,
  FileImageOutlined,
  ShareAltOutlined,
  LockOutlined,
  FolderFilled,
  ArrowLeftOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
  FilePptOutlined,
  FileExcelOutlined,
  FileUnknownOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import ViewTableBtn from "../../assets/images/view-icon.svg";
import EditTableBtn from "../../assets/images/action-edit-btn.svg";
import DeleteTableBtn from "../../assets/images/action-delete-btn.svg";
import DeleteModalBtn from "../../assets/images/delete-icon-modal.svg";
import PdfTableBtn from "../../assets/images/pdf-icon-table.svg";
import WordTableBtn from "../../assets/images/word-icon-table.svg";
import { Layout, Menu } from "antd";
import { Modal, Upload, message } from "antd";
import { UploadOutlined, PlusOutlined } from "@ant-design/icons";
import SingleImageUpload1 from "../../components/SingleImageUpload1";
import { ShowToast, Severty } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import moment from "moment";
import userPhoto from "../../assets/images/user.png"; // Default user image
import { useParams, useNavigate } from "react-router-dom";

// Permission helper
const getPermissionByName = (moduleName) => {
  try {
    const user = JSON.parse(localStorage.getItem("admin_userProfile") || "{}");
    if (user.type === "Admin") {
      return { view: true, add: true, edit: true, delete: true };
    }
    // Case/whitespace-insensitive match — see BlogTabs.js's identical fix.
    const normalizedTarget = String(moduleName || "").trim().toLowerCase();
    const permissions = user?.roleId?.permission || [];
    return (
      permissions.find(
        (p) => String(p?.name || "").trim().toLowerCase() === normalizedTarget
      ) || {}
    );
  } catch {
    return {};
  }
};

const { Option } = Select;

const { RangePicker } = DatePicker;

const { Panel } = Collapse;

const data = Array.from({ length: 8 }, (_, i) => ({
  key: i,
  fileName: "Office Document",
  uploader: {
    name: "Kaiya Lipshutz",
    avatar: "https://i.pravatar.cc/150?img=68",
  },
  uploadDate: "24 June, 2023 | 10:10 PM",
  fileType: i % 2 === 0 ? "pdf" : "word",
}));

const { Sider, Content } = Layout;

const VAULT_CATEGORIES = [
  "Contracts",
  "Invoices",
  "Addendums",
  "Pictures",
  "Artifacts",
  "Miscellaneous",
  "Data Models",
];

const ONBOARDING_QUESTION_MAP = {
  q1: "What is your current title, and how long have you held that title?",
  q2: "What do you hope to get out of Personal Branding?",
  q3: "What are the three most important global trends on your mind?",
  q4: "What are the top three Tech trends in your industry on your mind?",
  q5: "What are three topics or aspects that you would like to highlight on your profile?",
  q6: "Are there any organizations, certifications, or professional networks you are part of that you'd like to highlight?",
  q7: "What are the top three social causes you care about?",
  q8: "Choose 3 words your co-workers would define you as.",
  q9: "What are the topics you can talk endlessly about?",
  q10: "If you were to receive an award, what would it be for?",
  q11: "For you, what are 3 core values in an executive leader?",
  q12: "What have been the biggest hurdles in developing your personal brand?",
  q13: "What tone and style do you prefer for your posts?",
  q14: "What two steps could you immediately take to make the biggest difference in your social media popularity?",
  q15: "What are you most proud of professionally?",
  q16: "Think about one or two people who really inspire you — describe them in a word.",
  q17: "What are some hobbies and interests outside of the office that you do?",
  q18: "What is the compliment or acknowledgement you hear most often about yourself?",
  q19: "What activities/efforts do you do offline that help you in the office?",
  q20: "What are some of your favourite books?",
  q21: "What, according to you, are the key success factors of a great personal brand?",
  q22: "What will make this Personal Branding relationship rewarding for you?",
  q23: "What else would you like us to know?",
};

const BRAND_TASK_LABELS = {
  pbStrategyDeck: "PB Strategy Deck",
  linkedinAudit: "LinkedIn Audit",
  contentStrategyDeck: "Content Strategy Deck",
};

const ONBOARDING_NAV_KEY = "Onboarding";

const ICON_STYLE = { fontSize: 24 };

const IMAGE_EXTENSIONS   = ["png", "jpg", "jpeg", "gif", "svg", "webp", "jfif"];
const PDF_EXTENSIONS     = ["pdf"];
const OFFICE_EXTENSIONS  = ["doc", "docx", "xls", "xlsx", "csv", "ppt", "pptx", "txt"];
const ONENOTE_EXTENSIONS = ["one", "onepkg"];
// kept for any legacy usage elsewhere
const GOOGLE_VIEWER_EXTENSIONS = [...PDF_EXTENSIONS, ...OFFICE_EXTENSIONS];

const FILE_TYPE_MAP = {
  pdf:    { icon: <FilePdfOutlined    style={{ ...ICON_STYLE, color: "#d93025" }} />, label: "PDF"         },
  doc:    { icon: <FileWordOutlined   style={{ ...ICON_STYLE, color: "#2b579a" }} />, label: "DOC"         },
  docx:   { icon: <FileWordOutlined   style={{ ...ICON_STYLE, color: "#2b579a" }} />, label: "DOCX"        },
  xls:    { icon: <FileExcelOutlined  style={{ ...ICON_STYLE, color: "#207245" }} />, label: "XLS"         },
  xlsx:   { icon: <FileExcelOutlined  style={{ ...ICON_STYLE, color: "#207245" }} />, label: "XLSX"        },
  csv:    { icon: <FileExcelOutlined  style={{ ...ICON_STYLE, color: "#207245" }} />, label: "CSV"         },
  ppt:    { icon: <FilePptOutlined    style={{ ...ICON_STYLE, color: "#d24726" }} />, label: "PPT"         },
  pptx:   { icon: <FilePptOutlined    style={{ ...ICON_STYLE, color: "#d24726" }} />, label: "PPTX"        },
  txt:    { icon: <FileTextOutlined   style={{ ...ICON_STYLE, color: "#6b7280" }} />, label: "TXT"         },
  png:    { icon: <FileImageOutlined  style={{ ...ICON_STYLE, color: "#999"    }} />, label: "PNG"         },
  jpg:    { icon: <FileImageOutlined  style={{ ...ICON_STYLE, color: "#999"    }} />, label: "JPG"         },
  jpeg:   { icon: <FileImageOutlined  style={{ ...ICON_STYLE, color: "#999"    }} />, label: "JPEG"        },
  gif:    { icon: <FileImageOutlined  style={{ ...ICON_STYLE, color: "#999"    }} />, label: "GIF"         },
  svg:    { icon: <FileImageOutlined  style={{ ...ICON_STYLE, color: "#999"    }} />, label: "SVG"         },
  webp:   { icon: <FileImageOutlined  style={{ ...ICON_STYLE, color: "#999"    }} />, label: "WEBP"        },
  jfif:   { icon: <FileImageOutlined  style={{ ...ICON_STYLE, color: "#999"    }} />, label: "JFIF"        },
  // ── NEW ──────────────────────────────────────────────────────────────────────
  one:    { icon: <FileTextOutlined   style={{ ...ICON_STYLE, color: "#7719aa" }} />, label: "OneNote"     },
  onepkg: { icon: <FileTextOutlined   style={{ ...ICON_STYLE, color: "#7719aa" }} />, label: "OneNote Pkg" },
};

const stripQueryAndHash = (url = "") => url.split("#")[0].split("?")[0] || "";
const extractFileExtension = (url = "") => {
  const cleanUrl = stripQueryAndHash(url);
  const parts = cleanUrl.split(".");
  if (parts.length < 2) return "";
  return parts.pop().toLowerCase();
};

const resolveRecordExtension = (record = {}) => {
  const source = record.document || record.name || "";
  return extractFileExtension(source);
};

const getFileTypeMeta = (extension = "") => {
  const key = (extension || "").toLowerCase();
  return FILE_TYPE_MAP[key] || {
    icon: <FileUnknownOutlined style={{ ...ICON_STYLE, color: "#8c8c8c" }} />,
    label: key ? key.toUpperCase() : "UNKNOWN",
  };
};

const isImageExtension   = (ext = "") => IMAGE_EXTENSIONS.includes(ext.toLowerCase());
const isPdfExtension     = (ext = "") => PDF_EXTENSIONS.includes(ext.toLowerCase());
const isOfficeExtension  = (ext = "") => OFFICE_EXTENSIONS.includes(ext.toLowerCase());
const isOneNoteExtension = (ext = "") => ONENOTE_EXTENSIONS.includes(ext.toLowerCase());
const isGoogleViewerExtension = (ext = "") => GOOGLE_VIEWER_EXTENSIONS.includes(ext.toLowerCase());


// ─────────────────────────────────────────────────────────────────────────────
// Parse FileList from a webkitdirectory input into a manifest of vault items.
// ─────────────────────────────────────────────────────────────────────────────
const buildManifest = (fileArray) => {
  const manifest = [];
  const seenFolders = new Set();

  fileArray.forEach((file) => {
    const relPath = file.webkitRelativePath;
    const parts = relPath.split("/");

    for (let i = 1; i < parts.length; i++) {
      const folderPath = parts.slice(0, i).join("/");
      if (!seenFolders.has(folderPath)) {
        seenFolders.add(folderPath);
        manifest.push({ path: folderPath, name: parts[i - 1], type: "FOLDER" });
      }
    }

    manifest.push({ path: relPath, name: parts[parts.length - 1], type: "FILE", file });
  });

  return manifest;
};

const VaultTabs = () => {
  const navigate = useNavigate();
  const vaultPermission = getPermissionByName("Vault");
  
  // Redirect if user lacks view permission
  useEffect(() => {
    if (!vaultPermission?.view) {
      navigate("/dashboard");
    }
  }, [vaultPermission?.view]);
  
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [viewDocumentUrl, setViewDocumentUrl] = useState(null);
  const [previewFileExtension, setPreviewFileExtension] = useState("");
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewError, setPreviewError] = useState(false);
  const [previewInstanceKey, setPreviewInstanceKey] = useState(0);
  const { id } = useParams();
  const [visibilityModalOpen, setVisibilityModalOpen] = useState(false);
  const [visibilitySaving, setVisibilitySaving] = useState(false);
  const [visibilityRecord, setVisibilityRecord] = useState(null);
  const [visibilityState, setVisibilityState] = useState({
    brandStrategist: true,
    brandManager: true,
    brandHead: true,
  });
  
  const columns = [
    {
      title: "FILE NAME",
      dataIndex: "name",
      key: "name",
      render: (text, record) => {
        if (record.type === "FOLDER") {
          return (
            <div
              style={{ cursor: "pointer", color: "#1890ff", display: "flex", alignItems: "center", gap: "8px" }}
              onClick={() => handleFolderClick(record)}
            >
              <FolderFilled style={{ fontSize: 18 }} />
              {text}
            </div>
          );
        }
        return text;
      },
    },
    {
      title: "UPLOADED BY",
      key: "userId",
      render: (_, record) => (
        <div className="vault-upload-image">
          <Avatar src={record.userId.image || userPhoto} />
          <span>{record.userId.name}</span>
        </div>
      ),
    },
    {
      title: "UPLOAD DATE",
      dataIndex: "created_at",
      key: "created_at",
      render: (created_at) => {
        return moment(created_at).format("DD/MM/YYYY");
      },
    },
    {
      title: "FILE TYPE ICON",
      key: "fileType",
      render: (_, record) => {
        if (record.type === "FOLDER") {
          return (
            <div className="vault-upload-image" style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <FolderFilled style={{ fontSize: 24, color: "#faad14" }} />
              <span>FOLDER</span>
            </div>
          );
        }
        const extension = resolveRecordExtension(record);
        const meta = getFileTypeMeta(extension);

        return (
          <div className="vault-upload-image" style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {meta.icon}
            <span>{meta.label}</span>
          </div>
        );
      },
    },

    {
      title: "ACTION",
      key: "action",
      render: (record) => (
        <Space>
          {record.type !== "FOLDER" && (
            <Tooltip title="view">
              <Button
                className="table-light-fill-btn"
                onClick={() => handleView(record)}
              >
                <img src={ViewTableBtn} alt="View" />
              </Button>
            </Tooltip>
          )}
          {vaultPermission?.delete && (
            <Tooltip title={record.type === "FOLDER" ? "Delete Folder" : "Delete"}>
              <Button
                className="table-danger-fill-btn"
                onClick={() => handleDelete(record)}
              >
                <img src={DeleteTableBtn} alt="Delete" />
              </Button>
            </Tooltip>
          )}
          {vaultPermission?.view && record.type !== "FOLDER" && (
            <Tooltip title="Download">
              <Button className="">
                <a
                  href={record.document || ""}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  <DownloadOutlined />
                </a>
              </Button>
            </Tooltip>
          )}
          {vaultPermission?.edit && (
            <Tooltip title={record.type === "FOLDER" ? "Folder Visibility" : "More actions"}>
              <Button
                onClick={() => {
                  setVisibilityRecord(record);
                  const vis = record?.visibility || {};
                  setVisibilityState({
                    brandStrategist: vis.brandStrategist ?? true,
                    brandManager: vis.brandManager ?? true,
                    brandHead: vis.brandHead ?? true,
                  });
                  setVisibilityModalOpen(true);
                }}
              >
               <LockOutlined />
              </Button>
            </Tooltip>
          )}
          {vaultPermission?.view && record.type !== "FOLDER" && (
            <Tooltip title="Share Link">
              <Button
                className="vault-upload-image"
                icon={<ShareAltOutlined />}
              />
            </Tooltip>
          )}
          
        </Space>
      ),
    },
  ];
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [fileName, setFileName] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("Contracts");
  const [vaultData, setVaultData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [dateRange, setDateRange] = useState([]); // [startDate, endDate]
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 991 : false
  );
  const [fileType, setFileType] = useState(""); // For pdf / word filter
  const pageSize = 10;
  const { request } = useRequest();
  const [uploadVisibility, setUploadVisibility] = useState({
    brandStrategist: true,
    brandManager: true,
    brandHead: true,
  });

  // ── Client's own onboarding documents (resume/questionnaire/brand tasks) ──
  // Same data + layout as the client's own "My Onboarding" vault tab, sourced
  // from the Onboarding record rather than raw Vault documents.
  const [onboardingData, setOnboardingData] = useState(null);
  const [onboardingLoading, setOnboardingLoading] = useState(false);

  useEffect(() => {
    if (!id) return;
    setOnboardingLoading(true);
    request({
      url: `/admin/onboarding/status/${id}`,
      method: "GET",
      onSuccess: (res) => {
        setOnboardingData(res?.data?.onboarding || null);
        setOnboardingLoading(false);
      },
      onError: () => {
        setOnboardingData(null);
        setOnboardingLoading(false);
      },
    });
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const [currentFolderId, setCurrentFolderId] = useState(null);
  const [folderPath, setFolderPath] = useState([]);
  const [isFolderModalVisible, setIsFolderModalVisible] = useState(false);
  const [folderName, setFolderName] = useState("");
  const [creatingFolder, setCreatingFolder] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const categoryMenu = (
    <Menu
      mode={isMobile ? "horizontal" : "inline"}
      selectedKeys={[selectedCategory]}
      onClick={({ key }) => {
        setSelectedCategory(key);
        setCurrentPage(1);
      }}
      style={isMobile ? { borderBottom: 0 } : { height: "100%", borderRight: 0 }}
    >
      {onboardingData && (
        <Menu.Item className="valult-tabs-listing" key={ONBOARDING_NAV_KEY}>
          {ONBOARDING_NAV_KEY}
        </Menu.Item>
      )}
      {VAULT_CATEGORIES.map((cat) => (
        <Menu.Item className="valult-tabs-listing" key={cat}>
          {cat}
        </Menu.Item>
      ))}
    </Menu>
  );
  // ── Folder-upload state ───────────────────────────────────────────────────
  const folderInputRef = useRef(null);

  // Hidden SingleImageUpload1 bridge — reuses existing S3 upload path
  const hiddenUploaderRef = useRef(null);
  const uploadCallbackRef = useRef(null);
  const [hiddenUploaderKey, setHiddenUploaderKey] = useState(0);
  const [pendingUploadFile, setPendingUploadFile] = useState(null);

  // Progress modal state
  const [folderUploadVisible, setFolderUploadVisible]   = useState(false);
  const [folderUploadTotal, setFolderUploadTotal]       = useState(0);
  const [folderUploadDone, setFolderUploadDone]         = useState(0);
  const [folderUploadStatus, setFolderUploadStatus]     = useState("idle");
  const [folderUploadError, setFolderUploadError]       = useState("");
  const [folderUploadLog, setFolderUploadLog]           = useState([]);
  // ─────────────────────────────────────────────────────────────────────────

  // ── Preview flags ─────────────────────────────────────────────────────────
  const previewExtension  = previewFileExtension || extractFileExtension(viewDocumentUrl || "");
  const isImagePreview    = isImageExtension(previewExtension);
  const isPdfPreview      = isPdfExtension(previewExtension);
  const isOfficePreview   = isOfficeExtension(previewExtension);
  const isOneNoteFile     = isOneNoteExtension(previewExtension);
  const isDocPreview      = isPdfPreview || isOfficePreview;   // kept for compat
  const isExcelPreview    = ["xls", "xlsx"].includes((previewExtension || "").toLowerCase());
  const isPreviewSupported = isImagePreview || isPdfPreview || isOfficePreview;

  const buildDocViewerUrl = (url, cacheBuster) => {
    if (!url) return "";
    // PDF → Google Docs Viewer (Office Live does NOT support PDF)
    if (isPdfPreview) {
      return `https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true&_ts=${cacheBuster}`;
    }
    // Excel → Office Live with extra params
    if (isExcelPreview) {
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}&wdStartOn=1&wdPrint=0&_ts=${cacheBuster}`;
    }
    // All other Office types (doc, docx, ppt, pptx, csv, txt)
    return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}&_ts=${cacheBuster}`;
  };

  const resetPreviewState = () => {
    setViewDocumentUrl(null);
    setPreviewFileExtension("");
    setPreviewLoading(false);
    setPreviewError(false);
    setPreviewInstanceKey(0);
  };

  const fetchVaultData = async () => {
    if (selectedCategory === ONBOARDING_NAV_KEY) return;
    try {
      setLoading(true);
      const queryParams = [];

      queryParams.push(`category=${encodeURIComponent(selectedCategory)}`);
      queryParams.push(`page=${currentPage}`);
      queryParams.push(`limit=${pageSize}`);

      if (searchText) {
        queryParams.push(`search=${encodeURIComponent(searchText)}`);
      }

      if (dateRange.length === 2) {
        queryParams.push(`startDate=${dateRange[0].format("YYYY-MM-DD")}`);
        queryParams.push(`endDate=${dateRange[1].format("YYYY-MM-DD")}`);
      }
      if (fileType) {
        queryParams.push(`fileType=${fileType}`);
      }
      
      queryParams.push(`parentId=${currentFolderId || ""}`);

      const url = `/admin/access-module/vault/${id}?${queryParams.join("&")}`;

      const response = await request({
        url: url,
        method: "GET",
        onSuccess: (response) => {
          console.log("vault response",response);
          setVaultData(response.data.Vault.items);
          setTotalCount(response.data.Vault.total);
        },
        onError: (error) => {
          console.log("vault error",error);
          ShowToast(response.message, Severty.ERROR);
        },
      });
    } catch (err) {
      ShowToast("Error fetching vault data.", Severty.ERROR);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchVaultData();
  }, [selectedCategory, currentPage, fileType, searchText, dateRange, currentFolderId]);

  useEffect(() => {
    if (!viewDocumentUrl) {
      setPreviewLoading(false);
      return;
    }
    setPreviewLoading(isPreviewSupported);
    setPreviewError(false);
  }, [viewDocumentUrl, previewExtension, isPreviewSupported]);

  // Inject file into hidden SingleImageUpload1 whenever pendingUploadFile changes
  useEffect(() => {
    if (!pendingUploadFile) return;

    const timer = setTimeout(() => {
      const input = hiddenUploaderRef.current?.querySelector('input[type="file"]');
      if (!input) {
        uploadCallbackRef.current?.reject(
          new Error(`Hidden file input not found for: ${pendingUploadFile.name}`)
        );
        uploadCallbackRef.current = null;
        return;
      }

      try {
        const dt = new DataTransfer();
        dt.items.add(pendingUploadFile);

        const nativeDescriptor = Object.getOwnPropertyDescriptor(
          HTMLInputElement.prototype,
          "files"
        );
        if (nativeDescriptor?.set) {
          nativeDescriptor.set.call(input, dt.files);
        } else {
          Object.defineProperty(input, "files", { value: dt.files, configurable: true });
        }

        input.dispatchEvent(new Event("change", { bubbles: true }));
      } catch (err) {
        uploadCallbackRef.current?.reject(err);
        uploadCallbackRef.current = null;
      }
    }, 80);

    return () => clearTimeout(timer);
  }, [pendingUploadFile]);

  const uploadFileViaHiddenComponent = (file) =>
    new Promise((resolve, reject) => {
      uploadCallbackRef.current = { resolve, reject };
      setHiddenUploaderKey((k) => k + 1);
      setPendingUploadFile(file);
    });

  const handleFolderSelected = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (files.length === 0) return;

    if (!vaultPermission?.add) {
      ShowToast("You don't have permission to add vault documents!", Severty.ERROR);
      return;
    }

    const manifest = buildManifest(files);
    const fileItems = manifest.filter((item) => item.type === "FILE");

    setFolderUploadTotal(fileItems.length);
    setFolderUploadDone(0);
    setFolderUploadStatus("uploading");
    setFolderUploadError("");
    setFolderUploadLog([
      `Found ${fileItems.length} file(s) in ${manifest.filter((i) => i.type === "FOLDER").length} folder(s)...`,
    ]);
    setFolderUploadVisible(true);

    // Step 1: Upload every file to S3 via hidden component
    try {
      for (let i = 0; i < manifest.length; i++) {
        const item = manifest[i];
        if (item.type !== "FILE") continue;

        setFolderUploadLog((prev) => [...prev.slice(-4), `Uploading: ${item.path}`]);

        const s3Url = await uploadFileViaHiddenComponent(item.file);
        item.document = s3Url;

        // ✅ Call AI analysis if Data Models category
        if (selectedCategory === "Data Models") {
          setFolderUploadLog((prev) => [...prev.slice(-4), `AI analysis: ${item.path}`]);
          try {
            // Goes through the Node backend's proxy (not straight to
            // Imergey-AI) — same single-source pattern as Writing/Research
            // Assistant. Only the backend's IMERGEY_AI_URL env needs to know
            // Imergey-AI's address.
            const aiResponse = await request({
              url: "/admin/access-module/vault/ai-upload",
              method: "POST",
              data: {
                username: id,
                file_url: s3Url,
                file_name: item.name.trim(),
              },
            });
            if (aiResponse?.data?.status !== "success") {
              setFolderUploadStatus("error");
              setFolderUploadError(`AI analysis failed for ${item.name}.`);
              return;
            }
          } catch (aiErr) {
            setFolderUploadStatus("error");
            setFolderUploadError(`AI analysis error for ${item.name}.`);
            return;
          }
        }

        delete item.file;

        setFolderUploadDone((prev) => prev + 1);
      }
    } catch (uploadError) {
      setFolderUploadStatus("error");
      setFolderUploadError(uploadError.message || "File upload to S3 failed.");
      return;
    }

    // Step 2: Bulk create vault structure
    setFolderUploadStatus("creating");
    setFolderUploadLog((prev) => [...prev.slice(-4), "Creating vault structure..."]);

    const cleanManifest = manifest.map(({ file, ...rest }) => rest);

    request({
      url: `/admin/access-module/vault/${id}/bulk`,
      method: "POST",
      data: {
        items: cleanManifest,
        category: selectedCategory,
        visibility: uploadVisibility,
        rootParentId: currentFolderId || null,
      },
      onSuccess: (data) => {
        if (data.status === 200 || data.status === 201) {
          setFolderUploadStatus("done");
          setFolderUploadLog((prev) => [
            ...prev.slice(-4),
            `✓ Successfully created ${data.data?.count || cleanManifest.length} item(s).`,
          ]);
          fetchVaultData();
        } else {
          setFolderUploadStatus("error");
          setFolderUploadError(data.message || "Bulk create failed.");
        }
      },
      onError: () => {
        setFolderUploadStatus("error");
        setFolderUploadError("Failed to create vault entries.");
      },
    });
  };

  const handleUpload = async () => {
    if (!fileName.trim()) {
      ShowToast("Please enter a file name!", Severty.ERROR);
      return;
    }

    if (fileList.length === 0 || !fileList[0].url) {
      ShowToast("Please select and upload a file!", Severty.ERROR);
      return;
    }

    const payload = {
      name: fileName.trim(),
      document: fileList[0].url,
      category: selectedCategory,
      type: "FILE",
      parentId: currentFolderId,
    };

    if (vaultPermission?.edit) {
      payload.visibility = uploadVisibility;
    }

    try {
      setUploading(true);
      if (selectedCategory === "Data Models") {
        // Goes through the Node backend's proxy — same single-source pattern
        // as Writing/Research Assistant.
        const aiResponse = await request({
          url: "/admin/access-module/vault/ai-upload",
          method: "POST",
          data: {
            "username": id,
            "file_url": fileList[0].url,
            "file_name": fileName.trim()
          }
        });
        if (aiResponse?.data?.status !== "success") {
          ShowToast("File upload failed. Please try again.", Severty.ERROR);
          return;
        }
      }

      request({
        url: "/admin/access-module/vault/" + id,
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          if (data.status === 200) {
            ShowToast("Document saved successfully!", Severty.SUCCESS);
            setIsModalVisible(false);
            setFileList([]);
            setFileName("");
            setUploadVisibility({
              brandStrategist: true,
              brandManager: true,
              brandHead: true,
            });
            fetchVaultData();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: () => {
          ShowToast("Error saving document.", Severty.ERROR);
        },
        onFinally: () => setUploading(false),
      });
    } catch (error) {
      ShowToast("Error saving document.", Severty.ERROR);
    } finally {
      setUploading(false);
    }
  };

  const handleCreateFolder = () => {
    if (!folderName.trim()) {
      ShowToast("Please enter a folder name!", Severty.ERROR);
      return;
    }

    const payload = {
      name: folderName.trim(),
      type: "FOLDER",
      parentId: currentFolderId,
      category: selectedCategory,
    };

    setCreatingFolder(true);
    request({
      url: "/admin/access-module/vault/" + id,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        if (data.status === 200) {
          ShowToast("Folder created successfully!", Severty.SUCCESS);
          setIsFolderModalVisible(false);
          setFolderName("");
          fetchVaultData();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: () => {
        ShowToast("Error creating folder.", Severty.ERROR);
      },
      onFinally: () => setCreatingFolder(false),
    });
  };

  const handleSearch = (value) => {
    setSearchText(value);
    setCurrentPage(1);
  };
  const handleFolderClick = (record) => {
    setFolderPath((prev) => [...prev, record]);
    setCurrentFolderId(record._id);
    setCurrentPage(1);
  };
  const handleDateChange = (dates) => {
    setDateRange(dates || []);
    setCurrentPage(1);
  };

  const handleView = (record) => {
    if (!record?.document) {
      ShowToast("No document URL found.", Severty.ERROR);
      return;
    }

    resetPreviewState();

    const extension = resolveRecordExtension(record);
    const isImg    = isImageExtension(extension);
    const isPdf    = isPdfExtension(extension);
    const isOffice = isOfficeExtension(extension);

    setPreviewError(false);
    setPreviewFileExtension(extension);
    setPreviewLoading(isImg || isPdf || isOffice);
    setPreviewInstanceKey((k) => k + 1);
    setViewDocumentUrl(record.document);
    setViewModalVisible(true);
  };

  const closePreviewModal = () => {
    resetPreviewState();
    setViewModalVisible(false);
  };

  const handleDelete = (record) => {
    setSelectedRecord(record);
    setDeleteModalVisible(true);
  };

  return (
    <>
      {/* ── Hidden folder picker input ──────────────────────────────────── */}
      <input
        ref={folderInputRef}
        type="file"
        webkitdirectory="true"
        mozdirectory="true"
        directory="true"
        multiple
        style={{ display: "none" }}
        onChange={handleFolderSelected}
      />

      {/* ── Hidden SingleImageUpload1 bridge ───────────────────────────── */}
      <div
        ref={hiddenUploaderRef}
        style={{
          position: "absolute",
          left: "-9999px",
          top: 0,
          width: 1,
          height: 1,
          overflow: "hidden",
          opacity: 0,
          pointerEvents: "none",
        }}
      >
        <SingleImageUpload1
          key={hiddenUploaderKey}
          fileType={[
            "image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp", "image/svg+xml",
            "application/pdf", "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
            "application/vnd.ms-powerpoint",
            "text/plain", "text/csv",
            // ── NEW: OneNote ──────────────────────────────────────────────
            "application/onenote",
            "application/msonenote",
          ]}
          value={null}
          imageType="documents"
          btnName=""
          onChange={(result) => {
            if (!uploadCallbackRef.current) return;
            const { resolve, reject } = uploadCallbackRef.current;
            uploadCallbackRef.current = null;
            setPendingUploadFile(null);
            const url = Array.isArray(result) ? result[0]?.url : result?.url || result;
            if (url) resolve(url);
            else reject(new Error("Upload returned no URL"));
          }}
          size={500}
        />
      </div>

      <Layout className="vault-layout" style={{ minHeight: "100vh" }}>
        {!isMobile && (
          <Sider
            width={220}
            className="vault-sider"
            style={{ background: "#fff", borderRight: "1px solid #f0f0f0" }}
          >
            {categoryMenu}
          </Sider>
        )}
        <Layout>
          {isMobile && <div className="vault-category-bar">{categoryMenu}</div>}
          {selectedCategory === ONBOARDING_NAV_KEY && onboardingData ? (
            <Card title={ONBOARDING_NAV_KEY} bordered={false} className="criclebox tablespace mb-24" loading={onboardingLoading}>
              {/* Resume + questionnaire + brand-uploaded files */}
              <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
                {onboardingData.steps?.resumeUpload?.fileUrl && (
                  <a href={onboardingData.steps.resumeUpload.fileUrl} target="_blank" rel="noreferrer">
                    <Button icon={<DownloadOutlined />} size="small">Download Resume</Button>
                  </a>
                )}
                {onboardingData.steps?.questionnaire?.pdfUrl && (
                  <a href={onboardingData.steps.questionnaire.pdfUrl} target="_blank" rel="noreferrer">
                    <Button icon={<DownloadOutlined />} size="small">Download Questionnaire</Button>
                  </a>
                )}
                {Object.keys(BRAND_TASK_LABELS).map((key) => {
                  const task = onboardingData.brandTasks?.[key];
                  if (!task?.fileUrl) return null;
                  return (
                    <a key={key} href={task.fileUrl} target="_blank" rel="noreferrer">
                      <Button icon={<DownloadOutlined />} size="small">
                        {BRAND_TASK_LABELS[key]}
                      </Button>
                    </a>
                  );
                })}
              </div>

              {/* Pending brand tasks */}
              {onboardingData.brandOnboardingEnabled && (
                <div style={{ marginBottom: 16 }}>
                  {Object.keys(BRAND_TASK_LABELS).map((key) => {
                    const task = onboardingData.brandTasks?.[key];
                    if (task?.fileUrl) return null;
                    return (
                      <Tag key={key} style={{ marginBottom: 6 }}>
                        {BRAND_TASK_LABELS[key]}: Pending
                      </Tag>
                    );
                  })}
                </div>
              )}

              {/* Basic info */}
              {onboardingData.steps?.basicInfo?.data && (
                <div style={{ background: "#fafafa", borderRadius: 10, padding: "8px 14px", marginBottom: 16 }}>
                  {[
                    ["Full name", onboardingData.steps.basicInfo.data.fullName],
                    ["Company", onboardingData.steps.basicInfo.data.companyName],
                    ["Designation", onboardingData.steps.basicInfo.data.designation],
                    ["Industry", onboardingData.steps.basicInfo.data.industry],
                    ["Website", onboardingData.steps.basicInfo.data.companyWebsite],
                  ].map(([label, value]) =>
                    value ? (
                      <div key={label} style={{ display: "flex", gap: 8, padding: "7px 0", borderBottom: "1px solid #f0f0f0" }}>
                        <span style={{ width: 110, flexShrink: 0, fontSize: 12, color: "#888" }}>{label}</span>
                        <span style={{ fontSize: 13, color: "#1a1a1a", fontWeight: 500 }}>{value}</span>
                      </div>
                    ) : null
                  )}
                </div>
              )}

              {/* Questionnaire answers */}
              {onboardingData.steps?.questionnaire?.answers?.length > 0 && (
                <Collapse ghost>
                  <Panel header="Questionnaire Answers" key="qa">
                    {onboardingData.steps.questionnaire.answers.map((a, idx) => {
                      const label = ONBOARDING_QUESTION_MAP[a.id];
                      if (!label) return null;
                      const answer = Array.isArray(a.answer) ? a.answer.join(", ") : a.answer;
                      const hasAnswer = answer && String(answer).trim();
                      return (
                        <div key={a.id} style={{ marginBottom: 14 }}>
                          <div style={{ fontSize: 12, color: "#888", marginBottom: 3 }}>
                            Q{idx + 1}. {label}
                          </div>
                          <div style={{
                            fontSize: 13,
                            color: hasAnswer ? "#1a1a1a" : "#aaa",
                            fontStyle: hasAnswer ? "normal" : "italic",
                            background: "#f8f8f8", borderRadius: 6,
                            padding: "6px 10px",
                            borderLeft: `3px solid ${hasAnswer ? "#185250" : "#ddd"}`,
                          }}>
                            {hasAnswer ? answer : "Not answered"}
                          </div>
                        </div>
                      );
                    })}
                  </Panel>
                </Collapse>
              )}
            </Card>
          ) : null}
          {selectedCategory !== ONBOARDING_NAV_KEY && (
          <Card
            title="Vault"
            bordered={false}
            className="criclebox tablespace mb-24"
            extra={
              <div className="d-flex align-items-end gap-3 flex-wrap">
                {currentFolderId && (
                  <Button
                    icon={<ArrowLeftOutlined />}
                    onClick={() => {
                      const newPath = folderPath.slice(0, -1);
                      setFolderPath(newPath);
                      setCurrentFolderId(newPath.length ? newPath[newPath.length - 1]._id : null);
                    }}
                  >
                    Back
                  </Button>
                )}
                {vaultPermission?.view && (
                  <div className="pageHeadingSearch">
                    <Input.Search
                      placeholder="Search document"
                      className="searchInput"
                      allowClear
                      value={searchText}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSearchText(value);
                        handleSearch(value);
                      }}
                      onSearch={handleSearch}
                    />
                  </div>
                )}
                {vaultPermission?.view && (
                  <div className="role-wrap">
                    <RangePicker
                      placeholder={["Start Date", "End Date"]}
                      onChange={handleDateChange}
                    />
                  </div>
                )}
                {vaultPermission?.view && (
                  <div className="role-wrap">
                    <Select
                      placeholder="File Type"
                      style={{ width: 150 }}
                      value={fileType || undefined}
                      onChange={(value) => {
                        setFileType(value);
                        setCurrentPage(1);
                      }}
                      allowClear
                    >
                      <Option value="pdf">PDF</Option>
                      <Option value="word">Word</Option>
                    </Select>
                  </div>
                )}
                {vaultPermission?.add && (
                  <Button
                    type="default"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setIsFolderModalVisible(true);
                    }}
                  >
                    Create Folder
                  </Button>
                )}
                {vaultPermission?.add && (
                  <Button
                    type="default"
                    icon={<UploadOutlined />}
                    onClick={() => {
                      if (vaultPermission?.add) {
                        folderInputRef.current && folderInputRef.current.click();
                      } else {
                        ShowToast("You don't have permission to add vault documents!", Severty.ERROR);
                      }
                    }}
                  >
                    Upload Folder
                  </Button>
                )}
                {vaultPermission?.add && (
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setIsModalVisible(true);
                    }}
                  >
                    Add Document
                  </Button>
                )}
              </div>
            }
          >
            <Breadcrumb style={{ marginBottom: 16 }}>
              <Breadcrumb.Item
                onClick={() => {
                  setFolderPath([]);
                  setCurrentFolderId(null);
                }}
                style={{ cursor: "pointer" }}
              >
                Vault
              </Breadcrumb.Item>
              {folderPath.map((f, index) => (
                <Breadcrumb.Item
                  key={f._id}
                  onClick={() => {
                    const newPath = folderPath.slice(0, index + 1);
                    setFolderPath(newPath);
                    setCurrentFolderId(f._id);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {f.name}
                </Breadcrumb.Item>
              ))}
            </Breadcrumb>
            <div className="table-responsive">
              <Table
                columns={columns}
                dataSource={
                  (vaultData || []).sort((a, b) => {
                    if (a.type === "FOLDER" && b.type !== "FOLDER") return -1;
                    if (a.type !== "FOLDER" && b.type === "FOLDER") return 1;
                    return 0;
                  })
                }
                loading={loading}
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  total: totalCount,
                  onChange: (page) => setCurrentPage(page),
                  showSizeChanger: false,
                }}
                rowKey="_id"
              />
            </div>
            {vaultPermission?.add && (
              <Modal
                className="tab_modal"
                title="Upload Document"
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                onOk={handleUpload}
                confirmLoading={uploading}
              >
              <Input
                placeholder="Enter File Name"
                value={fileName}
                onChange={(e) => setFileName(e.target.value)}
                style={{ marginBottom: 16 }}
                disabled={!vaultPermission?.add}
              />

              {vaultPermission?.add && (
                <div className="role-wrap" style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 16 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span>Brand Strategist</span>
                    <Switch
                      checked={uploadVisibility.brandStrategist}
                      onChange={(checked) =>
                        setUploadVisibility((s) => ({ ...s, brandStrategist: checked }))
                      }
                    />
                  </div>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span>Brand Manager</span>
                    <Switch
                      checked={uploadVisibility.brandManager}
                      onChange={(checked) =>
                        setUploadVisibility((s) => ({ ...s, brandManager: checked }))
                      }
                    />
                  </div>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span>Brand Head</span>
                    <Switch
                      checked={uploadVisibility.brandHead}
                      onChange={(checked) =>
                        setUploadVisibility((s) => ({ ...s, brandHead: checked }))
                      }
                    />
                  </div>
                </div>
              )}

              <SingleImageUpload1
                fileType={[
                  "image/jpeg",
                  "image/jpg",
                  "image/png",
                  "image/gif",
                  "image/webp",
                  "image/svg+xml",
                  "application/pdf",
                  "application/msword",
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                  "application/vnd.ms-excel",
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                  "application/vnd.ms-powerpoint",
                  "text/plain",
                  "text/csv",
                  // ── NEW: OneNote ────────────────────────────────────────
                  "application/onenote",
                  "application/msonenote",
                ]}
                imageType="documents"
                btnName="File"
                onChange={(file) => {
                  console.log("S3 Upload:", file);
                  setFileList(file);
                }}
                size={500}
                disabled={!vaultPermission?.add}
              />
            </Modal>
            )}
          </Card>
          )}
        </Layout>
      </Layout>

      {/* ── Delete Modal ──────────────────────────────────────────────────── */}
      <Modal
        className="table_modal delete-modal"
        footer={false}
        title={false}
        width={450}
        visible={deleteModalVisible}
        onCancel={() => setDeleteModalVisible(false)}
      >
        <div className="delete-modal-body">
          <img src={DeleteModalBtn} alt="delete" />
          <h3>Are you sure?</h3>
          <p>Are you sure you want to delete this document?</p>
          {vaultPermission?.delete && (
            <Button
              className="delete-fill-btn"
              loading={loading}
              onClick={async () => {
                try {
                  setLoading(true);
                  const response = await request({
                    url: `/admin/access-module/vault/${selectedRecord._id}`,
                    method: "DELETE",
                  });
                  if (response.status === 200) {
                    ShowToast("Document deleted successfully!", Severty.SUCCESS);
                    setVaultData((prev) => prev.filter((item) => item._id !== selectedRecord._id));
                    fetchVaultData();
                  } else {
                    ShowToast(response.message, Severty.ERROR);
                  }
                } catch (err) {
                  ShowToast("Error deleting document.", Severty.ERROR);
                } finally {
                  setLoading(false);
                  setDeleteModalVisible(false);
                  setSelectedRecord(null);
                }
              }}
            >
              Yes, confirm
            </Button>
          )}
        </div>
      </Modal>

      {/* ── View Modal ────────────────────────────────────────────────────── */}
      {vaultPermission?.view && (
        <Modal
          className="table_modal view-modal"
          footer={false}
          title={false}
          width={1000}
          open={viewModalVisible}
          onCancel={closePreviewModal}
        >
          <div className="view-modal-body">
            <h3>Document Preview</h3>
            {viewDocumentUrl ? (
              <div style={{ position: "relative", minHeight: isPreviewSupported ? 620 : 200 }}>

                {previewLoading && (
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      background: "rgba(255,255,255,0.7)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 2,
                    }}
                  >
                    <Spin size="large" />
                  </div>
                )}

                {previewError ? (
                  <div style={{ height: "600px", display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center" }}>
                    <div>
                      <p style={{ marginBottom: 12 }}>Preview not available. Please download the file.</p>
                      <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        href={viewDocumentUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Download
                      </Button>
                    </div>
                  </div>

                ) : isImagePreview ? (
                  <img
                    src={viewDocumentUrl}
                    alt="Document preview"
                    style={{ maxWidth: "100%", maxHeight: 600, borderRadius: 8, display: "block", margin: "0 auto" }}
                    onLoad={() => setPreviewLoading(false)}
                    onError={() => {
                      setPreviewError(true);
                      setPreviewLoading(false);
                    }}
                  />

                ) : isPdfPreview ? (
                  <iframe
                    key={`pdf-${previewInstanceKey}`}
                    src={buildDocViewerUrl(viewDocumentUrl, previewInstanceKey)}
                    title="PDF Viewer"
                    width="100%"
                    height="600px"
                    frameBorder="0"
                    style={{ borderRadius: 8 }}
                    allowFullScreen
                    onLoad={() => setPreviewLoading(false)}
                    onError={() => {
                      setPreviewError(true);
                      setPreviewLoading(false);
                    }}
                  />

                ) : isOfficePreview ? (
                  <iframe
                    key={`office-${previewInstanceKey}`}
                    src={buildDocViewerUrl(viewDocumentUrl, previewInstanceKey)}
                    title="Office Viewer"
                    width="100%"
                    height="600px"
                    frameBorder="0"
                    style={{ borderRadius: 8 }}
                    allowFullScreen
                    onLoad={() => setPreviewLoading(false)}
                    onError={() => {
                      setPreviewError(true);
                      setPreviewLoading(false);
                    }}
                  />

                ) : isOneNoteFile ? (
                  <div style={{ height: "600px", display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center" }}>
                    <div>
                      <p style={{ marginBottom: 12 }}>
                        OneNote files cannot be previewed in the browser. Please download to open in Microsoft OneNote.
                      </p>
                      <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        href={viewDocumentUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Download .one file
                      </Button>
                    </div>
                  </div>

                ) : (
                  <div style={{ padding: 16, textAlign: "center" }}>
                    <p style={{ marginBottom: 12 }}>Preview not available. Please download the file.</p>
                    <Button
                      type="link"
                      icon={<DownloadOutlined />}
                      href={viewDocumentUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                    >
                      Download
                    </Button>
                  </div>
                )}

              </div>
            ) : (
              <p>No document to display.</p>
            )}
            <div style={{ marginTop: 16, textAlign: "right" }}>
              <Button onClick={closePreviewModal}>Close</Button>
            </div>
          </div>
        </Modal>
      )}

      {/* ── Visibility Modal ──────────────────────────────────────────────── */}
      {vaultPermission?.edit && (
        <Modal
          title="Manage Visibility"
          open={visibilityModalOpen}
          onCancel={() => setVisibilityModalOpen(false)}
          onOk={async () => {
            try {
              setVisibilitySaving(true);
              await request({
                url: `/admin/access-module/editVault/${visibilityRecord?._id}`,
                method: "PUT",
                data: { visibility: visibilityState },
                onSuccess: (data) => {
                  if (data.status === 200) {
                    ShowToast("Visibility updated", Severty.SUCCESS);
                    fetchVaultData();
                  } else {
                    ShowToast(data.message || "Failed to update visibility", Severty.ERROR);
                  }
                },
                onError: () => {
                  ShowToast("Error updating visibility", Severty.ERROR);
                },
              });
            } finally {
              setVisibilitySaving(false);
              setVisibilityModalOpen(false);
              setVisibilityRecord(null);
            }
          }}
          confirmLoading={visibilitySaving}
        >
          <div className="role-wrap" style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span>Brand Strategist</span>
              <Switch
                checked={visibilityState.brandStrategist}
                onChange={(checked) =>
                  setVisibilityState((s) => ({ ...s, brandStrategist: checked }))
                }
              />
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span>Brand Manager</span>
              <Switch
                checked={visibilityState.brandManager}
                onChange={(checked) =>
                  setVisibilityState((s) => ({ ...s, brandManager: checked }))
                }
              />
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span>Brand Head</span>
              <Switch
                checked={visibilityState.brandHead}
                onChange={(checked) =>
                  setVisibilityState((s) => ({ ...s, brandHead: checked }))
                }
              />
            </div>
          </div>
        </Modal>
      )}

      {/* ── Create Folder Modal ───────────────────────────────────────────── */}
      <Modal
        title="Create Folder"
        visible={isFolderModalVisible}
        onCancel={() => setIsFolderModalVisible(false)}
        onOk={handleCreateFolder}
        confirmLoading={creatingFolder}
      >
        <Input
          placeholder="Enter Folder Name"
          value={folderName}
          onChange={(e) => setFolderName(e.target.value)}
        />
      </Modal>

      {/* ── Folder Upload Progress Modal ──────────────────────────────────── */}
      <Modal
        title={
          <span>
            <UploadOutlined style={{ marginRight: 8 }} />
            Uploading Folder
          </span>
        }
        visible={folderUploadVisible}
        footer={
          folderUploadStatus === "done" || folderUploadStatus === "error" ? (
            <Button type="primary" onClick={() => setFolderUploadVisible(false)}>
              Close
            </Button>
          ) : null
        }
        closable={folderUploadStatus === "done" || folderUploadStatus === "error"}
        onCancel={() => {
          if (folderUploadStatus === "done" || folderUploadStatus === "error") {
            setFolderUploadVisible(false);
          }
        }}
        maskClosable={false}
        width={480}
      >
        <div style={{ textAlign: "center", marginBottom: 16 }}>
          {folderUploadStatus === "done" && (
            <CheckCircleFilled style={{ fontSize: 40, color: "#52c41a" }} />
          )}
          {folderUploadStatus === "error" && (
            <CloseCircleFilled style={{ fontSize: 40, color: "#ff4d4f" }} />
          )}
        </div>

        <p style={{ textAlign: "center", fontWeight: 500, marginBottom: 8 }}>
          {folderUploadStatus === "uploading" &&
            `Uploading files to storage (${folderUploadDone} / ${folderUploadTotal})`}
          {folderUploadStatus === "creating" && "Creating vault structure…"}
          {folderUploadStatus === "done"     && "Upload complete!"}
          {folderUploadStatus === "error"    && "Upload failed"}
        </p>

        {(folderUploadStatus === "uploading" || folderUploadStatus === "creating") && (
          <Progress
            percent={folderUploadTotal > 0 ? Math.round((folderUploadDone / folderUploadTotal) * 100) : 0}
            status="active"
            style={{ marginBottom: 16 }}
          />
        )}

        {folderUploadStatus === "error" && folderUploadError && (
          <p style={{ color: "#ff4d4f", textAlign: "center" }}>{folderUploadError}</p>
        )}

        <div
          style={{
            background: "#f5f5f5",
            borderRadius: 6,
            padding: "8px 12px",
            maxHeight: 120,
            overflowY: "auto",
            fontFamily: "monospace",
            fontSize: 12,
            color: "#555",
          }}
        >
          {folderUploadLog.map((line, i) => (
            <div key={i}>{line}</div>
          ))}
        </div>
      </Modal>
    </>
  );
};

export default VaultTabs;
